<template>
  <v-dialog v-model="dialog"
            fullscreen
            hide-overlay
            scrollable
            activator="#btn_select_content"
            transition="dialog-bottom-transition"
            @click:outside.prevent="close">
    <v-card class="CL_ContentPickerDialog AppComposeCard">
      <v-card-title>
        Select spaces to share
      </v-card-title>
      <v-card-actions class="d-block px-3">
        <div class="d-flex mb-2">
          <v-btn @click.prevent="submit"
                 color="primary"
                 :disabled="!canInsertLinks || form.spaces.length === 0"
                 class="mr-2">
            Insert {{ form.spaces.length | pluralize('space') }}
          </v-btn>
          <v-btn @click.prevent="cancelInsertLinks">
            Cancel
          </v-btn>
        </div>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-list>
          <template v-for="space in spaces">
            <v-list-item :key="space.id"
                         two-line>
              <v-list-item-action>
                <v-checkbox v-model="form.spaces"
                            :value="space.id">
                </v-checkbox>
              </v-list-item-action>
              <v-list-item-content @click.prevent="toggleSpace(space.id)"
                                   style="cursor: pointer;">
                <v-list-item-title>
                  {{ space.title }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="space.subtitle">
                  {{ space.subtitle }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn :href="space.preview_url"
                       target="_blank"
                       small>
                  Preview
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
import FolderDrawer from '../../../content/components/FolderDrawer';

export default {
  components: {FolderDrawer},
  props: {
    form: {
      type: Object,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'spaces',
    ]),
    canInsertLinks() {
      return this.spaces.length > 0;
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
    },
    close() {
      //console.log('close()');
      this.$emit('close');
      //this.dialog = false;
    },
    cancelInsertLinks() {
      this.form.spaces = [];
      this.close();
    },
    toggleSpace(spaceID) {
      if (this.form.spaces.includes(spaceID)) {
        this.form.spaces = this.form.spaces.filter(id => id !== spaceID);
      } else {
        this.form.spaces.push(spaceID);
      }
    },
    submit() { // MLD-3113
      this.$emit('insert');
    }
  },
}
</script>
